// utils/helpers.js
import { T } from "./theme";

export const urgencyColor = (elapsed, max) => {
  const pct = elapsed / max;
  if (pct < 0.4) return T.green;
  if (pct < 0.7) return T.orange;
  return T.red;
};

export const elapsedLabel = (sec) => {
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return m > 0 ? `${m}m ${s}s` : `${s}s`;
};

export const statusMeta = (status) =>
  ({
    new: {
      label: "NEW",
      color: T.orange,
      bg: T.orangeLight,
      border: T.orangeBorder,
    },
    "in-progress": {
      label: "COOKING",
      color: T.yellow,
      bg: T.yellowLight,
      border: T.yellowBorder,
    },
    ready: {
      label: "READY",
      color: T.green,
      bg: T.greenLight,
      border: T.greenBorder,
    },
  }[status]);

export function groupItemsByName(orders) {
  const map = {};
  orders.forEach((order) => {
    order.items.forEach((item, idx) => {
      if (!map[item.name]) map[item.name] = [];
      map[item.name].push({
        orderId: order.id,
        table: order.table,
        type: order.type,
        elapsed: order.elapsed,
        done: item.done,
        station: item.station,
        itemIdx: idx,
      });
    });
  });
  return map;
}